module.exports = __webpack_public_path__ + "static/img/img-seguridad-vial-moto.b872e75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seguro-motos/img-seguridad-vial-moto.png
// module id = 67tr
// module chunks = 0